import { Api as api } from "../api";
const prefix = "/config";
// const prefix = "";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    fuelTypeServiceV1ListFuelTypes: build.query<
      FuelTypeServiceV1ListFuelTypesApiResponse,
      FuelTypeServiceV1ListFuelTypesApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/fuel-types`,
        params: {
          page: queryArg.page,
          size: queryArg.size,
          sort: queryArg.sort,
          order: queryArg.order,
          status: queryArg.status,
          fuel_type_name: queryArg.fuelTypeName,
          effective_date: queryArg.effectiveDate,
          description: queryArg.description,
          price_fuel: queryArg.priceFuel,
          created_at_from: queryArg.createdAtFrom,
          created_at_to: queryArg.createdAtTo,
          updated_at_from: queryArg.updatedAtFrom,
          updated_at_to: queryArg.updatedAtTo,
        },
      }),
    }),
    fuelTypeServiceV1BatchCreateFuelType: build.mutation<
      FuelTypeServiceV1BatchCreateFuelTypeApiResponse,
      FuelTypeServiceV1BatchCreateFuelTypeApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/fuel-types`,
        method: "POST",
        body: queryArg.fuelTypeV1BatchCreateFuelTypeReq,
      }),
    }),
    fuelTypeServiceV1ActivateFuelTypes: build.mutation<
      FuelTypeServiceV1ActivateFuelTypesApiResponse,
      FuelTypeServiceV1ActivateFuelTypesApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/fuel-types/activate`,
        method: "PATCH",
        body: queryArg.fuelTypeV1FuelTypeBulkStatusChangeReq,
      }),
    }),
    fuelTypeServiceV1DeactivateFuelTypes: build.mutation<
      FuelTypeServiceV1DeactivateFuelTypesApiResponse,
      FuelTypeServiceV1DeactivateFuelTypesApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/fuel-types/deactivate`,
        method: "PATCH",
        body: queryArg.fuelTypeV1FuelTypeBulkStatusChangeReq,
      }),
    }),
    fuelTypeServiceV1GetFuelTypeDropdown: build.query<
      FuelTypeServiceV1GetFuelTypeDropdownApiResponse,
      FuelTypeServiceV1GetFuelTypeDropdownApiArg
    >({
      query: () => ({ url: `${prefix}/v1/fuel-types/dropdown` }),
    }),
    fuelTypeServiceV1GetFuelType: build.query<
      FuelTypeServiceV1GetFuelTypeApiResponse,
      FuelTypeServiceV1GetFuelTypeApiArg
    >({
      query: (queryArg) => ({ url: `${prefix}/v1/fuel-types/${queryArg.id}` }),
    }),
    fuelTypeServiceV1UpdateFuelType: build.mutation<
      FuelTypeServiceV1UpdateFuelTypeApiResponse,
      FuelTypeServiceV1UpdateFuelTypeApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/fuel-types/${queryArg.id}`,
        method: "PUT",
        body: queryArg.fuelTypeServiceV1UpdateFuelTypeBody,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as fuelTypeApi };
export type FuelTypeServiceV1ListFuelTypesApiResponse =
  /** status 200 A successful response. */ FuelTypeV1ListFuelTypesRes;
export type FuelTypeServiceV1ListFuelTypesApiArg = {
  page?: number;
  size?: number;
  sort?: string;
  order?: string;
  status?: string;
  fuelTypeName?: string;
  effectiveDate?: string;
  description?: string;
  priceFuel?: number;
  createdAtFrom?: string;
  createdAtTo?: string;
  updatedAtFrom?: string;
  updatedAtTo?: string;
};
export type FuelTypeServiceV1BatchCreateFuelTypeApiResponse =
  /** status 200 A successful response. */ FuelTypeV1FuelTypeMessageRes;
export type FuelTypeServiceV1BatchCreateFuelTypeApiArg = {
  fuelTypeV1BatchCreateFuelTypeReq: FuelTypeV1BatchCreateFuelTypeReq;
};
export type FuelTypeServiceV1ActivateFuelTypesApiResponse =
  /** status 200 A successful response. */ FuelTypeV1FuelTypeBulkStatusChangeRes;
export type FuelTypeServiceV1ActivateFuelTypesApiArg = {
  fuelTypeV1FuelTypeBulkStatusChangeReq: FuelTypeV1FuelTypeBulkStatusChangeReq;
};
export type FuelTypeServiceV1DeactivateFuelTypesApiResponse =
  /** status 200 A successful response. */ FuelTypeV1FuelTypeBulkStatusChangeRes;
export type FuelTypeServiceV1DeactivateFuelTypesApiArg = {
  fuelTypeV1FuelTypeBulkStatusChangeReq: FuelTypeV1FuelTypeBulkStatusChangeReq;
};
export type FuelTypeServiceV1GetFuelTypeDropdownApiResponse =
  /** status 200 A successful response. */ FuelTypeV1GetFuelTypeDropdownRes;
export type FuelTypeServiceV1GetFuelTypeDropdownApiArg = void;
export type FuelTypeServiceV1GetFuelTypeApiResponse =
  /** status 200 A successful response. */ FuelTypeV1FuelTypeDetailRes;
export type FuelTypeServiceV1GetFuelTypeApiArg = {
  id: string;
};
export type FuelTypeServiceV1UpdateFuelTypeApiResponse =
  /** status 200 A successful response. */ FuelTypeV1FuelTypeMessageRes;
export type FuelTypeServiceV1UpdateFuelTypeApiArg = {
  id: string;
  fuelTypeServiceV1UpdateFuelTypeBody: FuelTypeServiceV1UpdateFuelTypeBody;
};
export type FuelTypeV1FuelTypeRes = {
  id?: string;
  fuel_type_name?: string;
  price_fuel?: number;
  effective_date?: string;
  description?: string;
  status?: string;
  created_by?: string;
  updated_by?: string;
  created_at?: string;
  updated_at?: string;
};
export type FuelTypeV1FuelTypePaginationMeta = {
  total?: number;
  current_page?: number;
  limit?: number;
  total_item?: number;
  total_page?: number;
  have_next_page?: boolean;
  have_previous_page?: boolean;
};
export type FuelTypeV1ListFuelTypesRes = {
  fuel_types?: FuelTypeV1FuelTypeRes[];
  metadata?: FuelTypeV1FuelTypePaginationMeta;
};
export type ProtobufAny = {
  "@type"?: string;
  [key: string]: any;
};
export type RpcStatus = {
  code?: number;
  message?: string;
  details?: ProtobufAny[];
};
export type FuelTypeV1FuelTypeMessageRes = {
  message?: string;
};
export type FuelTypeV1CreateFuelTypeItem = {
  fuel_type_name: string;
  price_fuel: number;
  effective_date: string;
  description?: string;
  status: string;
};
export type FuelTypeV1BatchCreateFuelTypeReq = {
  fuel_types: FuelTypeV1CreateFuelTypeItem[];
};
export type FuelTypeV1FuelTypeBulkStatusChangeRes = {
  message?: string;
  updated_count?: number;
};
export type FuelTypeV1FuelTypeBulkStatusChangeReq = {
  ids: string[];
};
export type FuelTypeV1FuelTypeDropdownItem = {
  id?: string;
  fuel_type_name?: string;
};
export type FuelTypeV1GetFuelTypeDropdownRes = {
  fuel_types?: FuelTypeV1FuelTypeDropdownItem[];
};
export type FuelTypeV1FuelTypeDetailRes = {
  id?: string;
  fuel_type_name?: string;
  price_fuel?: number;
  effective_date?: string;
  description?: string;
  status?: string;
  created_by?: string;
  updated_by?: string;
  created_at?: string;
  updated_at?: string;
};
export type FuelTypeServiceV1UpdateFuelTypeBody = {
  fuel_type_name: string;
  price_fuel: number;
  effective_date: string;
  description?: string;
};
export const {
  useFuelTypeServiceV1ListFuelTypesQuery,
  useFuelTypeServiceV1BatchCreateFuelTypeMutation,
  useFuelTypeServiceV1ActivateFuelTypesMutation,
  useFuelTypeServiceV1DeactivateFuelTypesMutation,
  useFuelTypeServiceV1GetFuelTypeDropdownQuery,
  useFuelTypeServiceV1GetFuelTypeQuery,
  useFuelTypeServiceV1UpdateFuelTypeMutation,
} = injectedRtkApi;
